import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Angle___init__impl__g23q1m(turns) {
  return turns;
}
function _Angle___get_turns__impl__atdtw5($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.eb2_1 = 6.2831855;
        this.fb2_1 = 360.0;
        this.gb2_1 = _Angle___init__impl__g23q1m(0.0);
        this.hb2_1 = _Angle___init__impl__g23q1m(1.0);
        this.ib2_1 = _Angle___init__impl__g23q1m(0.5);
        this.jb2_1 = _Angle___init__impl__g23q1m(0.25);
        this.kb2_1 = _Angle___init__impl__g23q1m(0.125);
        this.lb2_1 = _Angle___init__impl__g23q1m(1 / 3.0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Angle__toString_impl_786qky($this) {
  return 'Angle(turns=' + $this + ')';
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle()))
    return false;
  var tmp0_other_with_cast = other.acy_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AngleClass;
function Angle() {
  if (AngleClass === VOID) {
    class $ {
      constructor(turns) {
        Companion_getInstance();
        this.acy_1 = turns;
      }
      toString() {
        return Angle__toString_impl_786qky(this.acy_1);
      }
      hashCode() {
        return Angle__hashCode_impl_szcndt(this.acy_1);
      }
      equals(other) {
        return Angle__equals_impl_zcf5mt(this.acy_1, other);
      }
    }
    initMetadataForClass($, 'Angle');
    AngleClass = $;
  }
  return AngleClass;
}
//region block: exports
export {
  Angle as Angle36m0cdko0c63j,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1mpxbjdjfwrarw,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndt7z0bvq6vi9u2,
  Angle__toString_impl_786qky as Angle__toString_impl_786qky3amgxlk310y0l,
  _Angle___get_turns__impl__atdtw5 as _Angle___get_turns__impl__atdtw5dv920nekm6fo,
  Companion_getInstance as Companion_getInstanceeghlbkcb6su6,
};
//endregion

//# sourceMappingURL=Angle.mjs.map
